import React, { Component, StrictMode } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './ImageInput.scss';
import { TEXT_FIELD_IS_REQUIRED } from '../../../utils/messages';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';

const placeholder = require('./assets/placeholder.png');
const uploadArrow = require('./assets/upload-arrow.svg');
const preloader = require('./assets/preloader.svg');

class ImageInput extends Component {
  static propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    name: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    registerField: PropTypes.func.isRequired,
  }
  static defaultProps = {
    value: placeholder,
    disabled: false,
    loading: false,
    isRequired: false,
  }

  state = {
    viewImage: placeholder,
  }

  componentDidMount() {
    const { name, registerField } = this.props;
    registerField({ name, validator: this.standardValidator });
  }

  componentDidUpdate(prevProps) {
    const { value: nextValue } = this.props;
    const { viewImage } = this.state;
    if (nextValue.length && typeof nextValue === 'string' && nextValue !== viewImage) {
      this.setState(() => ({
        viewImage: nextValue,
      }));
    }

    if (prevProps.value !== nextValue && !nextValue.length) {
      this.setState(() => ({
        viewImage: placeholder,
      }));
    }
    if (typeof nextValue === 'object') {
      this.readFileUrl(nextValue);
    }
  }

  changeHandler = (e) => {
    e.preventDefault();
    const {
      target: {
        files,
      },
    } = e;
    const { name, changeHandler } = this.props;
    changeHandler({ value: files[0], name });
  }

  standardValidator = (value) => {
    const { isRequired } = this.props;
    let valid = true;
    let errorText = '';
    if (isRequired && !(value && value.length)) {
      valid = false;
      errorText = TEXT_FIELD_IS_REQUIRED;
    }
    const status = valid
      ? TEXT_FIELD_STATUS.VALID
      : TEXT_FIELD_STATUS.INVALID;
    return { status, errorText };
  };

  readFileUrl = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const { viewImage } = this.state;
        if (viewImage !== reader.result) {
          this.setState(() => ({
            viewImage: reader.result,
          }));
        }
      };
      reader.readAsDataURL(file);
    }
  }

  render() {
    const { disabled, loading } = this.props;
    const { viewImage } = this.state;
    const imageInputClasses = classNames({ 'image-input': true, disabled, loading });
    return (
      <StrictMode>
        <div className={imageInputClasses}>
          <label htmlFor="image-input"><img src={viewImage} alt="loadedImage" />
            {/* value=""  for that case, when user upload image across input
              then change it via link and then again across link */}
            <input
              value=""
              disabled={disabled}
              onChange={this.changeHandler}
              name="image-input"
              type="file"
            /> {!disabled && <div className="image-input-overlay"><img src={uploadArrow} alt="upload-arrow" /></div>}
            <div className="image-preloader">
              <img src={preloader} alt="preloader" />
            </div>
          </label>

        </div>
      </StrictMode>
    );
  }
}

export default ImageInput;



// WEBPACK FOOTER //
// ./src/components/_molecules/ImageInput/ImageInput.js